import { useMemo } from 'react';
import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';
import useCanAccessOrgDashboard from './useCanAccessOrgDashboard';

const useOrgVenues = ({ attachedToAccount = false } = {}) => {
  const { accountId } = useAccount();
  const canAccess = useCanAccessOrgDashboard();

  const storeKey = useMemo(() => ['orgVenues', accountId, attachedToAccount], [accountId, attachedToAccount]);

  const { isLoading, data } = useQuery(storeKey, () => api.fetchOrgVenues({ accountId, attachedToAccount }), {
    enabled: !!accountId && canAccess
  });

  const orgVenues = useMemo(() => data?.data || [], [data?.data]);
  const orgVenuesOptions = useMemo(() => orgVenues.map(({ id, name }) => ({ value: id, label: name })), [orgVenues]);

  return { isLoading, orgVenues, orgVenuesOptions };
};

export default useOrgVenues;
